export const normalizeIsoDate = (
  value?: string | Date | null
): string | undefined => {
  if (!value) return undefined
  if (value instanceof Date) {
    return value.toISOString().split('T')[0]
  }
  return value
}

export const normalizeDecimalString = (value?: string | null): string => {
  if (!value) return ''
  return value.replace(',', '.').trim()
}
